/**
 * Shared page header component with icon, title, and description.
 * Use this on all panel pages for consistent heading style.
 */

import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export function PageHeader({
  icon: Icon,
  title,
  description,
  actions,
  iconColor,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  iconColor?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-start justify-between gap-3 mb-4', className)}>
      <div className="flex items-center gap-2.5 min-w-0">
        {Icon && (
          <div className={cn(
            'h-8 w-8 rounded-lg flex items-center justify-center shrink-0',
            iconColor || 'bg-[#5048e5]/10 text-[#5048e5]'
          )}>
            <Icon className="h-4 w-4" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight truncate">{title}</h1>
          {description && (
            <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
          )}
        </div>
      </div>
      {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
    </div>
  );
}
